export default __webpack_public_path__ + "static/personajes1A-e6113dcbec97176f067a3fe5b2bf2432.png";